import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { isPushEnabled, getSeenFilings, markFilingsSeen, parseCr, firePushNotification } from "@/lib/watchlist";

// This component silently polls filings; when enabled, notifies on new >₹500Cr filings
export default function PushAlertsRunner() {
  const [go, setGo] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setGo(true), 4000);
    return () => clearTimeout(t);
  }, []);
  const { data } = useQuery({
    queryKey: ["push-filings"],
    queryFn: async () => (await api.get("/filings?limit=40")).data,
    refetchInterval: 60_000,
    enabled: go,
  });

  useEffect(() => {
    if (!isPushEnabled()) return;
    const items = data?.data || [];
    const seen = getSeenFilings();
    const newBig = items.filter(f => !seen.has(f.id) && parseCr(f.order_value) >= 500);
    if (newBig.length === 0) {
      markFilingsSeen(items.map(f => f.id));
      return;
    }
    newBig.slice(0, 3).forEach(f => {
      firePushNotification(
        `${f.exchange} · ${f.order_value || 'Big Filing'}`,
        `${f.company}: ${f.headline}`,
        f.link
      );
    });
    markFilingsSeen(items.map(f => f.id));
    // Module-level helper fns (isPushEnabled, getSeenFilings, markFilingsSeen,
    // parseCr, firePushNotification) are stable imports.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return null;
}
